/*
 * @Description: 未能显示您的品牌详情
 * @Author: yy
 * @Date: 2019-02-11 14:37:10
 * @LastEditors: yy
 * @LastEditTime: 2019-06-04 16:05:33
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Floattip.css';
import Link from '../Link'


class Floattip extends React.Component {
  render() {
    const { show, close } = this.props
    return (
      <div className={s.root}>
        <div className={s.connet}>

          <div className={show ? s.floatTip : s.hide}>
            <span className={s.txtBlod}>未能显示您的品牌详情</span>
            <span>
              原因可能是您的品牌尚未收录在DBRank品牌库中，若您有此需求，请点击
              <a href="javascript:;" onClick={close}>确认</a>
              ，客户经理将专线联系您。若是您填写的品牌名称有误，请前往
              <Link to='/homepage'>个人中心</Link>
              修改。
            </span>
          </div>

          <span
            className={s.cardClose}
            onClick={close}>×</span>
        </div>

        <div className={s.model}>
          <div className={s.tipBox}>
            <div className={s.tipTxt}>感谢您的支持！请保持手机畅通，稍后数据顾问将 主动联系您。</div>
            <div className={s.tipOK}>确认</div>
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(s)(Floattip);



// WEBPACK FOOTER //
// src/components/Floattip/Floattip.js